module.exports = __webpack_public_path__ + "static/img/BHKWII.2e332db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AIR_BHKWII/BHKWII.jpg
// module id = /m10
// module chunks = 0